// removed by extract-text-webpack-plugin
module.exports = {"table":"_3PcR","select":"UhQ2"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Voices/VoiceSampleList/VoiceSampleList.scss
// module id = IY8Q
// module chunks = 0